export type Announcement = {
  id: string;
  label: string;
  text: string;
  to: string;
  linkLabel: string;
  startsAt: string;
  endsAt: string;
};

// One announcement at a time; set to null to turn the bar off.
// Give each new message a new id, so a visitor who closed the last one still sees it.
// Times are UTC: 05:00Z is midnight in Jamaica.
export const ANNOUNCEMENT: Announcement | null = {
  id: "kiosk-video-2026-10",
  label: "New",
  text: "Cash Redemption Kiosk: self-service ticket payouts for your venue.",
  to: "/product/6abd00000000000000000001",
  linkLabel: "Watch the video →",
  startsAt: "2026-10-24T05:00:00Z",
  endsAt: "2026-12-01T05:00:00Z",
};
